import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import {
  getDepartmentDetails,
  clearDepartmentDetails,
} from 'actions/department.action'
import { clearNewsByTags } from 'actions/news.action'
import { RootState } from 'reducers/rootReducer'

export interface DepartmentDetailsProps {}

export const useDepartmentDetails = (props: DepartmentDetailsProps) => {
  const dispatch = useAppDispatch()

  const { slug } = useParams<{ slug: string }>()

  const departmentDetails = useSelector(
    (state: RootState) => state.department.departmentDetails
  )
  const isLoading = useSelector(
    (state: RootState) => state.department.isLoading
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (!departmentDetails && slug) dispatch(getDepartmentDetails(slug))
  }, [departmentDetails, slug])

  useEffect(() => {
    return () => {
      dispatch(clearDepartmentDetails())
      dispatch(clearNewsByTags())
    }
  }, [dispatch, slug])

  return {
    ...props,
    departmentDetails,
    isLoading,
  }
}
